class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();

      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if(event.srcElement.className == 'subscriptionRadioFormat' || event.srcElement.className == 'rc-selling-plans-dropdown__select')
      return;

    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));

    UpdateFreeShippingWidget();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.freeShippingWidget',
      },
      {
        id: 'cart-header-block-wrapper',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart-header-block',
      },
      {
        id: 'cart-samples-block-wrapper',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart-items-samples-block-items',
      },
      {
        id: 'free-shipping-checkout-snippet-header',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.free-shipping-checkout-snippet',
      }
    ];
  }

  updateQuantity(line, quantity, name) {

    this.enableLoading(line);

    var body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    var updateURL = `${routes.cart_change_url}`;
    fetch(updateURL, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        //console.log("quantity = " + quantity);
        //console.log("state = " + state);
        
        this.getSectionsToRender().forEach((section => {
          //console.log("section.id = " + section.id + " | section.selector = " + section.selector);
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          var replacementHtml = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          //console.log("replacementHtml = " + replacementHtml);
          elementToReplace.innerHTML = replacementHtml;
        }));
      
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        if(quantity == 0)
        {
          cartSuggestedItemsBuild();
        }
        CartAutoSamplesUpdate();
        document.getElementById('cart-errors').textContent = '';
      }).catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        console.log(error);
        this.disableLoading();
      });
  }
  
  updateQuantityDeprecated(line, quantity, name) {

    this.enableLoading(line);

    var body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    var updateURL = `${routes.cart_change_url}`;
    fetch(updateURL, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        //console.log("quantity = " + quantity);
        //console.log("state = " + state);
        
        this.getSectionsToRender().forEach((section => {
          //console.log("section.id = " + section.id + " | section.selector = " + section.selector);
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          var replacementHtml = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          //console.log("replacementHtml = " + replacementHtml);
          if(replacementHtml != null)
            elementToReplace.innerHTML = replacementHtml;
        }));
      
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
        if(quantity == 0)
        {
          cartSuggestedItemsBuild();
        }
        CartAutoSamplesUpdate();
        document.getElementById('cart-errors').textContent = '';
      }).catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        console.log(error);
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    var domParserResults = new DOMParser().parseFromString(html, 'text/html');

    var selectorResults = domParserResults.querySelector(selector);


    if(selectorResults == null)
      return null;
    
    
    return selectorResults.innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}


var RefreshCartDataInProgress = false;
function RefreshCartData()
{
  
  if(RefreshCartDataInProgress)
    return;
  RefreshCartDataInProgress = true;
  
  const cartUrl = '/cart';
  fetch(cartUrl)
  .then(response => response.text())
  .then(html => {
    const htmlParser = new DOMParser();
    //console.log('response html = ' + html);
    const documentParsed = htmlParser.parseFromString(html, 'text/html');
    const newCartItemsElement = documentParsed.querySelector('.cart-items');
    const newFooterjscontents = documentParsed.querySelector('.cart__footer .js-contents');
    const newSamplesContentsItems = documentParsed.querySelector('#cart-items-sample-block-main .cart-items-samples-block-items');
    const newSamplesContentsValidation = documentParsed.querySelector('#cart-items-sample-block-main .cart-items-samples-block-validation');
    const newShippingWidgetContentsFooter = documentParsed.querySelector('.cart__footer .freeShippingWidget');
    const newShippingWidgetContentsHeader = documentParsed.querySelector('#free-shipping-checkout-snippet-header .free-shipping-checkout-snippet');
    const newHeaderContents = documentParsed.querySelector('#cart-header-block-wrapper .cart-header-block');
    
    //console.log('newShippingWidgetContentsHeader = ' + newShippingWidgetContentsHeader);

    const currentHeaderContents = document.querySelector('#cart-header-block-wrapper .cart-header-block');
    currentHeaderContents.parentNode.replaceChild(newHeaderContents, currentHeaderContents);

    const emptyCartQuery = documentParsed.querySelector("cart-items.is-empty");
    if(emptyCartQuery != null)
    {
      const currentCartMaster = document.querySelector('cart-items');
      const currentCartFooterMaster = document.querySelector('.cart__footer');
      currentCartMaster.parentNode.replaceChild(emptyCartQuery, currentCartMaster);
      currentCartFooterMaster.innerHTML = '';
      //console.log("emptyCartQuery");
      RefreshCartDataInProgress = false;
      return;
    }
    
    const currentCartItems = document.querySelector('.cart-items');
    if(currentCartItems != null && newCartItemsElement != null)
      currentCartItems.parentNode.replaceChild(newCartItemsElement, currentCartItems);

    
    

    //console.log("newCartItemsElement:");
    //console.log(newCartItemsElement);
    
    const currentFooterjscontents = document.querySelector('.cart__footer .js-contents');
    currentFooterjscontents.parentNode.replaceChild(newFooterjscontents,currentFooterjscontents);


    var currentSamplesContentsItems = document.querySelector('#cart-items-sample-block-main .cart-items-samples-block-items');   
    if(currentSamplesContentsItems != null && newSamplesContentsItems != null)
      currentSamplesContentsItems.parentNode.replaceChild(newSamplesContentsItems, currentSamplesContentsItems);

    var currentSamplesContentsValidation = document.querySelector('#cart-items-sample-block-main .cart-items-samples-block-validation');   
    if(currentSamplesContentsValidation != null && newSamplesContentsValidation != null)
      currentSamplesContentsValidation.parentNode.replaceChild(newSamplesContentsValidation, currentSamplesContentsValidation);

    const currentShippingWidgetContentsHeader = document.querySelector('#free-shipping-checkout-snippet-header .free-shipping-checkout-snippet');
    currentShippingWidgetContentsHeader.parentNode.replaceChild(newShippingWidgetContentsHeader,currentShippingWidgetContentsHeader);
    
    const currentShippingWidgetContentsFooter = document.querySelector('.cart__footer .freeShippingWidget');
    currentShippingWidgetContentsFooter.parentNode.replaceChild(newShippingWidgetContentsFooter,currentShippingWidgetContentsFooter);
    
    
    cartSuggestedItemsBuild();
    CartSamplesCheckShouldExpand();

    RefreshCartDataInProgress = false;
  })
  .catch(error => console.log('error getting cart contents', error));
}


customElements.define('cart-items', CartItems);
